import { FC } from 'react';
import { DropdownArrowIcon } from 'components/common/Icons';
import { AffordabilityCalculatorForm, CalculatorPages } from 'pages/CalculatorPage/types';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { IApplicantsSidebarProps } from './types';

export const ApplicantsSidebar: FC<IApplicantsSidebarProps> = ({ className }) => {
  const [, setSearchParams] = useSearchParams();
  const form = useFormContext<AffordabilityCalculatorForm>();
  const formFields = form.watch();
  const isApplicantsViewHidden = formFields.isApplicantsViewHidden;

  const switchApplicantViewHandler = () => {
    const isApplicantsViewHidden = form.getValues('isApplicantsViewHidden');

    form.setValue('isApplicantsViewHidden', !isApplicantsViewHidden);
  };

  const redirectToApplicantDetails = (applicantNumber: string, isAccessible: boolean) => {
    if (!isAccessible) return;

    setSearchParams({ section: CalculatorPages.applicantDetails, applicantNumber });
  };

  return (
    <div className={className}>
      <button
        type={'button'}
        onClick={switchApplicantViewHandler}
        className={
          'hover:text-dark text-main text-ms my-2 flex cursor-pointer items-center border-none bg-white p-0 font-medium'
        }
      >
        <FormattedMessage id={'affordabilityCalculator.layout.hide'} />
        <div className={`ml-2 flex items-center ${isApplicantsViewHidden && 'rotate-180'}`}>
          <DropdownArrowIcon />
        </div>
      </button>
      {!isApplicantsViewHidden &&
        formFields.applicants.map((applicant, applicantIndex) => (
          <button
            type={'button'}
            key={'applicant' + applicantIndex}
            className={`my-2 block border-none bg-white p-0 text-base font-medium underline ${
              applicant?.isFilled ? 'hover:text-dark text-main cursor-pointer' : 'text-ash cursor-default'
            }`}
            onClick={() => redirectToApplicantDetails(String(applicantIndex), applicant?.isFilled ?? false)}
          >
            <FormattedMessage
              id={'affordabilityCalculator.layout.applicant'}
              values={{ applicantIndex: applicantIndex + 1 }}
            />
          </button>
        ))}
    </div>
  );
};
